/*
    Конфигурация дашборда
*/

import {PModuleType} from '@/enums/configs';
import AccelerometerWidgetComponent from '@/components/widgets/accelerometerWidget/AccelerometerWidget.vue';
import WorkersWidgetComponent from '@/components/widgets/WorkersWidgetComponent.vue';
import WorkloadWidgetComponent from '@/components/widgets/WorkloadWidgetComponent.vue';
import AngleWidgetComponent from '@/components/widgets/AngleWidgetComponent.vue';
import NodeSummaryComponent from '@/components/widgets/nodeSummary/NodeSummaryComponent.vue';
import NodeHealthWidgetComponent from '@/components/widgets/NodeHealthWidgetComponent.vue';
import SpectrumHarmWidgetComponent from '@/components/widgets/SpectrumHarmWidgetComponent.vue';
import HitDetectorWidgetComponent from '@/components/widgets/HitDetectorWidgetComponent.vue';
import {VueConstructor} from 'vue/types/umd';
import {SensorType} from '../enums';
import {HitDetectorWidgetIntervalType} from '@/components/widgets/base/bindForms/enums';
import TemperatureSensor from '@c/sensorConfigs/OrTemperatureSensor.vue';
import AccelerometerSensor from '@c/sensorConfigs/OrAccelerometerSensor.vue';
import TahoSensor from '@c/sensorConfigs/OrTahoSensor.vue';
import EnergySensor from '@c/sensorConfigs/OrEnergySensor.vue';
import CleanStorageModule from '@c/sensorConfigs/OrCleanStorageModule.vue';
import ServerMonitorModule from '@c/sensorConfigs/OrServerMonitorModule.vue';

/*
  Словарь для биндинга компоненты датчика по типу датчика
  TODO выяснить куда делить тахометры по литрам и Revs
*/
export const sensorTypeComponentMap: Map<PModuleType, any> = new Map<PModuleType, any>([
  [PModuleType.DtcpTahoModule, TahoSensor],
  [PModuleType.CrmModule, TahoSensor],
  [PModuleType.DtcpTemperatureModule, TemperatureSensor],
  [PModuleType.DtcpEnergyModule, EnergySensor],
  [PModuleType.DtcpAccelerometerModule, AccelerometerSensor],
  [PModuleType.CleanStorageModule, CleanStorageModule],
  [PModuleType.ServerMonitorModule, ServerMonitorModule],
]);

/*
    Словарь запрещенных типов значений датчика для отображение в виде карточки на дашборде
*/
export const forbiddenSensorValueInfoesMap: Map<PModuleType, string[]> = new Map<
  PModuleType,
  string[]
>([
  // [PModuleType.TahoModule, []],
  // [PModuleType.OrTahoModuleLiters, []],
  // [PModuleType.OrTahoModuleRevs, []],
  [PModuleType.CrmModule, []],
]);

/*
    Словарь биндинга компонент для виджетов
*/
export const widgetComponentBindingMap: Map<string, VueConstructor> = new Map<
  string,
  VueConstructor
>([
  ['AccelerometerWidget', AccelerometerWidgetComponent],
  ['WorkersWidgetComponent', WorkersWidgetComponent],
  ['WorkloadWidgetComponent', WorkloadWidgetComponent],
  ['NodeSummaryComponent', NodeSummaryComponent],
  ['NodeHealthWidgetComponent', NodeHealthWidgetComponent],
  ['SpectrumHarmWidgetComponent', SpectrumHarmWidgetComponent],
  ['HitDetectorWidgetComponent', HitDetectorWidgetComponent],
  ['AngleWidgetComponent', AngleWidgetComponent],
]);

//Тестовый список карточек-компонент TODO: потом убрать

//TODO: не создавать вложенных объектов, т. к. используется копирование
export function getWidgetTemplates(): any[] {
  return [
    {
      //TODO: не использовать templateId под идентификатор БД
      templateId: '5eb11bd99ea0a368ab5e9896',
      x: 0,
      y: 0,
      w: 4,
      h: 8,
      static: false,
      name: 'Измерение вибрации',
      shortName: 'Измерение вибрации',
      type: SensorType.Component, //TODO: Потом убрать разделение на датчики и компоненты
      componentName: 'AccelerometerWidget',
      isResizable: false,
    },

    //TODO: Временно убран
    /*
    {
      //TODO: не использовать templateId под идентификатор БД
      templateId: '5eb11bd99ea0ra368ab5e12e4',
      x: 0,
      y: 0,
      w: 2,
      h: 4,
      static: false,
      name: 'Штат узла',
      shortName: 'Штат узла',
      type: SensorType.Component,
      componentName: 'WorkersWidgetComponent',
      isResizable: false,
      amount: 3,
    },*/

    {
      //TODO: не использовать templateId под идентификатор БД
      templateId: '5ef494f19ea0a36d5b00f582',
      x: 0,
      y: 0,
      w: 3,
      h: 6,
      static: false,
      name: 'Загруженность узла',
      shortName: 'Загруженность узла',
      type: SensorType.Component,
      componentName: 'WorkloadWidgetComponent',
      isResizable: false,
    },

    {
      //TODO: не использовать templateId под идентификатор БД
      templateId: 'fs6f80oiemb1ppk65v5jlg7r',
      x: 0,
      y: 0,
      w: 3,
      h: 8,
      static: false,
      name: 'Угол фазы',
      shortName: 'Угол фазы',
      type: SensorType.Component,
      componentName: 'AngleWidgetComponent',
      isResizable: false,
    },

    {
      //TODO: не использовать templateId под идентификатор БД
      templateId: '7ef494f55ea0a46d5b00f581',
      x: 0,
      y: 0,
      w: 3,
      h: 8,
      static: false,
      name: 'Сводная информация узла',
      shortName: 'Свод. информ. узла',
      type: SensorType.Component,
      componentName: 'NodeSummaryComponent',
      isResizable: false,
    },

    //TODO: временно убран
    /*{
      //TODO: не использовать templateId под идентификатор БД
      templateId: '71f494f55ea0a46d5b01f581',
      x: 0,
      y: 0,
      w: 2,
      h: 4,
      static: false,
      name: 'Жизнеспособность узла',
      shortName: 'Жизн. узла',
      type: SensorType.Component,
      componentName: 'NodeHealthWidgetComponent',
      isResizable: false,
    },*/

    {
      //TODO: не использовать templateId под идентификатор БД
      templateId: '71f494f511a0a46d5b01f581',
      x: 0,
      y: 0,
      w: 2,
      h: 4,
      static: false,
      name: 'Нулевая гармоника спектра огибающей',
      shortName: 'НГСО',
      type: SensorType.Component,
      componentName: 'SpectrumHarmWidgetComponent',
      isResizable: false,
    },

    {
      //TODO: не использовать templateId под идентификатор БД
      templateId: '7ef464f5aea0a46d5b00f581',
      x: 0,
      y: 0,
      w: 5,
      h: 6,
      static: false,
      name: 'Детектор ударов',
      shortName: 'Детектор ударов',
      type: SensorType.Component,
      componentName: 'HitDetectorWidgetComponent',
      isResizable: false,
      intervalType: HitDetectorWidgetIntervalType.Days,
      period: 12,
    },
  ];
}

//Размеры экрана для установки количества колонок в layout
export enum SensorDeskLayoutWidth {
  Ssd = 300,
  Sd = 500,
  Md = 700,
  Ld = 1000,
}

// Количество колонок в layout для виджетов
export enum SensorDeskColumns {
  Ld = 24,
  Md = 16,
  Sd = 12,
  Ssd = 8,
  Sssd = 4,
}
